import React from 'react';
import { ListItemIcon, ListItemText } from '@mui/material';
import TAGSvgIcon from '../TAGSvgIcon/TAGSvgIcon';

var DropdownItem = function DropdownItem(_ref) {
  var iconBoolean = _ref.iconBoolean,
      iconName = _ref.iconName,
      itemText = _ref.itemText;
  return React.createElement(React.Fragment, null, iconBoolean ? React.createElement(ListItemIcon, {
    sx: {
      display: 'flex',
      color: 'black',
      alignItems: 'center'
    }
  }, React.createElement(TAGSvgIcon, {
    icon: iconName,
    size: 20
  }), " ", React.createElement(ListItemText, {
    sx: {
      pl: 2
    }
  }, itemText)) : React.createElement(ListItemText, null, itemText));
};

export default DropdownItem;